import { createReducer, on } from '@ngrx/store';
import * as ReviewActions from '../actions/review.actions';
import { reviewAdapter, ReviewsState } from './review.entity';
import { strideAdapter, AnalysisStrideState } from './stride.entity';

export const reviewFeatureKey = 'review';

export interface State {
  loading: boolean;
  loaded: boolean;
  strides: AnalysisStrideState;
  reviews: ReviewsState;
  reviewId: string | null;
}

export const initialState: State = {
  loading: false,
  loaded: false,
  strides: strideAdapter.getInitialState(),
  reviews: reviewAdapter.getInitialState(),
  reviewId: null,
};

export const reducer = createReducer(
  initialState,

  on(ReviewActions.loadSingleReview, (state, { reviewId }) => ({
    ...state,
    loading: true,
    reviewId: reviewId,
  })),
  on(ReviewActions.addSingleReview, (state, { review }) => ({
    ...state,
    reviews: reviewAdapter.addOne(review, state.reviews),
  })),
  on(ReviewActions.addStrideList, (state, { strideList }) => ({
    ...state,
    strides: strideList !== null ? strideAdapter.addMany(strideList, state.strides) : state.strides,
  })),
  on(ReviewActions.updateSingleStride, (state, { update }) => ({
    ...state,
    strides: strideAdapter.updateOne(update, state.strides),
  })),
  on(ReviewActions.loadReviews, (state) => ({
    ...state,
    loading: true,
  })),
  on(ReviewActions.addReviews, (state, { reviews }) => ({
    ...state,
    loading: false,
    loaded: true,
    reviews: reviewAdapter.addMany(reviews, state.reviews),
  })),
  on(ReviewActions.loadReviewsSuccess, (state) => state),
  on(ReviewActions.loadReviewsFailure, (state) => state),
  on(ReviewActions.clearStrides, (state) => ({
    ...state,
    strides: strideAdapter.removeAll({ ...state.strides, ids: [] }),
  }))
);
